import { useCometControlBrowserSkillEnabledVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useCometControlBrowserSkillEnabledVariation.js';
import { useIsModeVisible } from '#pplx/frontend/apps/ask/hooks/search-model-selection-hooks/useIsModeVisible.js';
import { useApiSearchModes } from '#pplx/frontend/apps/ask/search-modes-menu/useApiSearchModes.js';
import { isSidecarSupportedMode, SearchMode, } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
/**
 * The search modes a surface may actually offer, after product visibility,
 * Sidecar support, feature-flag and omission rules are applied. Shared so the
 * menu and the control that opens it agree on what is available.
 */
export const useVisibleSearchModes = ({ omittedSearchModes = EMPTY_ARRAY, } = {}) => {
    const isModeVisible = useIsModeVisible();
    const { variation: isControlBrowserSkillEnabled } = useCometControlBrowserSkillEnabledVariation({
        defaultValue: false,
    });
    const isSidecar = !!import.meta.env.VITE_IS_SIDECAR_BUILD;
    const { modes: allModes } = useApiSearchModes({
        reason: 'search-mode-menu-items',
        enabled: false,
    });
    return allModes.filter((mode) => {
        if (omittedSearchModes.some((omittedMode) => omittedMode === mode.id)) {
            return false;
        }
        // In sidecar, only show modes from the centralized allowlist
        if (isSidecar && !isSidecarSupportedMode(mode.id)) {
            return false;
        }
        // only filter out feature-flagged modes, not subscription-gated modes
        const isVisible = isModeVisible(mode.id);
        if (mode.id === SearchMode.BROWSER_AGENT && isVisible && isControlBrowserSkillEnabled) {
            return false;
        }
        return isVisible;
    });
};
//# sourceMappingURL=useVisibleSearchModes.js.map